export const phraseArray = [
	{
		phrase: 'Weapons Robotics and Control Engineering',
		theme: 'Department Name'
	},
	{
		phrase: 'I like Dronez',
		theme: 'Enthusiastic Survey Comment About UAS Class'
	}
];
